import { createAsyncReducer } from '@telstra-connect/standard-actions/reducers';
import {
    ILoadGlobalFilterLocationsAction,
    ILoadGlobalFilterLocationsSuccessAction,
    ILoadGlobalFilterLocationsErrorAction
} from '@telstra-connect/tickets/actions/global/filter-locations';
import { ITicketsState } from '@telstra-connect/tickets/state';
import { initialState } from '@telstra-connect/tickets/reducers/initial-state';

export type LoadGlobalFilterLocationsAction
    = ILoadGlobalFilterLocationsAction
    | ILoadGlobalFilterLocationsSuccessAction
    | ILoadGlobalFilterLocationsErrorAction;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const init = (state: ITicketsState, action: LoadGlobalFilterLocationsAction) => ({
    ...state,
    globalFilteredLocations: initialState.globalFilteredLocations,
});

const success = (state: ITicketsState, action: LoadGlobalFilterLocationsAction) => ({
    ...state,
    globalFilteredLocations: {
        locations: (action as ILoadGlobalFilterLocationsSuccessAction).data,
        status: action.status
    }
});

const failure = (state: ITicketsState, action: LoadGlobalFilterLocationsAction) => ({
    ...state,
    globalFilteredLocations: {
        ...initialState.globalFilteredLocations,
        error: (action as ILoadGlobalFilterLocationsErrorAction).error,
        status: action.status,
        locations: []
    }
});

export const globalFilterLocationsReducer = createAsyncReducer(initialState, init, success, failure);
